export class PipeInsertaTeeUtility {
  static ftDivider = 12

  constructor(inches) {
    this.inches = inches
  }

  get ft() {
    return this.inches / PipeInsertaTeeUtility.ftDivider
  }
}

export default class PipeInsertaTee {
  static TYPE = {
    _M: {
      identifier:null,
      tConnections: 3,
      imgType: 'PIPE_INSERTA_TEE',
      od: new PipeInsertaTeeUtility(30),
      width: new PipeInsertaTeeUtility(30),
      length: new PipeInsertaTeeUtility(30),
      description: '36" X 90" Demo',
    },
    _3698AN: {
      tConnections: 3,
      imgType: 'PIPE_INSERTA_TEE',
      od: new PipeInsertaTeeUtility(30),
      width: new PipeInsertaTeeUtility(52.3),
      length: new PipeInsertaTeeUtility(52.3),
      description: '36" X 90" Demo',
    },
  }
}



// WEBPACK FOOTER //
// ./src/lib/Pipes/PipeAccessories/pipe-insertaTee.js